<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <div v-for="(val, key, index) in requiredColumnsOnImport" :key="index" class="my-2">
      <!-- *voting categories* .. when importing building owners -->
      <b-row v-if="key == '*voting_categories*'">
        <b-col>
          <b-row>
            <b-col cols="4">
              <!-- {{ key }} -->
              Catégories de vote
            </b-col>
            <b-col>
              est une charge générale
            </b-col>
          </b-row>
          <b-row
            v-for="(item, votingCategoryIndex) in requiredColumnsOnImport[key]"
            :key="item.keyId"
            class="my-2"
          >
            <b-col cols="4">
              <ValidationProvider
                v-slot="{ errors, classes }"
                :name="$t('catalogs.modal.voting_category_name') + '-' + votingCategoryIndex"
                rules="required"
              >
                <b-input
                  v-model="requiredColumnsOnImport[key][votingCategoryIndex].name"
                  :disabled="requiredColumnsOnImport[key][votingCategoryIndex].already_exists"
                ></b-input>
                <span v-if="errors[0]" :class="classes">{{
                  "Vous devez avoir au moins une catégorie de vote"
                }}</span>
              </ValidationProvider>
            </b-col>
            <b-col cols="2" class="text-center">
              <b-form-checkbox
                v-model="requiredColumnsOnImport[key][votingCategoryIndex].is_charge_generale"
                :value="1"
                :unchecked-value="0"
                class="d-inline"
                @change="setOtherChargeGeneraleToFalse(votingCategoryIndex)"
              />
            </b-col>

            <b-col cols="4">
              <ValidationProvider
                v-slot="{ errors, classes }"
                :name="'catégories de vote'"
                rules="required"
              >
                <b-form-select
                  v-model="requiredColumnsOnImport[key][votingCategoryIndex].doc_table_column"
                  class="d-block mx-auto"
                  :options="importedFileHeaderColumns"
                  @change="onVotingCategoryOptionChange($event, votingCategoryIndex)"
                />
                <span :class="classes">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>
            <b-col
              v-if="!requiredColumnsOnImport[key][votingCategoryIndex].already_exists"
              cols="2"
            >
              <b-button
                class="button btn-grey px-3 py-2 d-flex align-items-center"
                @click="removeVotingCategory(votingCategoryIndex)"
              >
                <font-awesome-icon icon="times"></font-awesome-icon>
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button
                class="button btn-blue px-3 py-2 d-flex align-items-center"
                @click="addVotingCategory"
              >
                <font-awesome-icon icon="plus"></font-awesome-icon>
              </b-button>
            </b-col>
            <b-col cols="9" class="d-flex align-items-center">
              <div v-show="!isChargeGeneral" class="text-danger">
                {{ "Veuillez ajouter au moins une charge générales" }}
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- default -->
      <b-row v-else>
        <b-col cols="6" class="text-center">
          <!-- {{ key }} -->
          {{ $t("catalogs.modal." + key) }}
        </b-col>
        <b-col cols="4" class="d-flex">
          <ValidationProvider
            v-slot="{ errors, classes }"
            :name="$t('catalogs.modal.' + key)"
            :rules="checkIfRequired(key)"
            class="w-100"
          >
            <b-form-select
              v-model="requiredColumnsOnImport[key]"
              class="d-block mx-auto"
              :options="customOptions(key)"
            />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
          <div v-if="key == 'country'" class="d-flex align-items-center">
            <font-awesome-icon
              id="popover-presence-country"
              icon="info-circle"
              size="1x"
              class="mx-2"
            />
            <b-popover target="popover-presence-country" triggers="hover" placement="top">
              Types autorisés : FR, US, UK, etc
            </b-popover>
          </div>
          <div v-if="key == 'contact_type'" class="d-flex align-items-center">
            <font-awesome-icon
              id="popover-presence-contact-type"
              icon="info-circle"
              size="1x"
              class="mx-2"
            />
            <b-popover target="popover-presence-contact-type" triggers="hover" placement="top">
              Types autorisés : <br />
              <span class="ml-3">E - Email</span> <br />
              <span class="ml-3">LRE - Lre</span> <br />
              <span class="ml-3">CP - Courrier postal</span> <br />
              <span class="ml-3">REMP - Remise en main propre</span> <br />
            </b-popover>
          </div>
          <div v-if="key == 'gender'" class="d-flex align-items-center">
            <font-awesome-icon
              id="popover-presence-gender"
              icon="info-circle"
              size="1x"
              class="mx-2"
            />
            <b-popover target="popover-presence-gender" triggers="hover" placement="top">
              Types autorisés : <br />
              <span class="ml-3">M - Monsieur</span> <br />
              <span class="ml-3">MME - Madame</span> <br />
              <span class="ml-3">MEM - Monsieur et Madame</span> <br />
              <span class="ml-3">MOM - Monsieur ou Madame</span> <br />
            </b-popover>
          </div>
          <div v-if="key == 'entity_type'" class="d-flex align-items-center">
            <font-awesome-icon
              id="popover-presence-entity-type"
              icon="info-circle"
              size="1x"
              class="mx-2"
            />
            <b-popover target="popover-presence-entity-type" triggers="hover" placement="top">
              Types autorisés : <br />
              <span class="ml-3">P - Particulier</span> <br />
              <span class="ml-3">PRO - Professionnel</span> <br />
            </b-popover>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="invalidCountryCodes.length > 0"
      class="text-danger w-100 d-flex justify-content-center"
    >
      {{ "Le nom du pays n'est pas correct: " + invalidCountryCodes.join(", ") }}
    </div>
    <div
      v-if="invalidContactTypes.length > 0"
      class="text-danger w-100 d-flex justify-content-center"
    >
      {{ "Type d’envoi préféré n'est pas correct: " + invalidContactTypes.join(", ") }}
    </div>
    <div
      v-if="invalidGenderTypes.length > 0"
      class="text-danger w-100 d-flex justify-content-center"
    >
      {{ "Civilité n'est pas correct: " + invalidGenderTypes.join(", ") }}
    </div>
    <div
      v-if="invalidEntityTypes.length > 0"
      class="text-danger w-100 d-flex justify-content-center"
    >
      {{ "Type d'entité n'est pas correct: " + invalidEntityTypes.join(", ") }}
    </div>
    <div class="w-100 d-flex justify-content-between">
      <b-button class="button btn-grey mt-3" @click="close">Fermer</b-button>
      <b-button variant="primary" class="button btn-blue mt-3 ml-3" @click="handleSubmit(set)">
        Importer les copropriétaires
      </b-button>
    </div>
  </ValidationObserver>
</template>

<script>
import VotingCategoryMW from "@/middlewares/VotingCategory";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
var uniqid = require("uniqid");

export default {
  props: {
    requiredColumnsOnImport: {
      type: Object,
      default: () => {
        return {};
      },
    },
    importedFileHeaderColumns: {
      type: Array,
      default: () => {
        return {};
      },
    },
    buildingId: {
      type: String,
      default: "",
      required: true,
    },
    invalidCountryCodes: {
      type: Array,
      default: () => {
        return {};
      },
    },
    invalidContactTypes: {
      type: Array,
      default: () => {
        return {};
      },
    },
    invalidGenderTypes: {
      type: Array,
      default: () => {
        return {};
      },
    },
    invalidEntityTypes: {
      type: Array,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isChargeGeneral: true,
      notRequired: [
        "firstname",
        "gender",
        "email",
        "complement",
        "complement_2",
        "contact_type",
        "entity_type",
      ],
    };
  },
  async created() {
    await VotingCategoryMW.FETCH(this.buildingId).catch(err => {
      this.$swal(this.alertError());
    });

    var votingCategories = VotingCategoryORM.query().where("building_id", this.buildingId).get();

    this.requiredColumnsOnImport["*voting_categories*"] = [];
    votingCategories.forEach(element => {
      this.requiredColumnsOnImport["*voting_categories*"].push({
        id: element.id,
        name: element.name,
        is_charge_generale: element.is_charge_generale,
        doc_table_column: "",
        already_exists: true,
        keyId: uniqid(),
      });
    });
    // Check if there are not voting_categories, and add one in order to force the user to create a charge general vote category
    if (this.requiredColumnsOnImport["*voting_categories*"].length == 0) {
      this.requiredColumnsOnImport["*voting_categories*"].push({
        name: "",
        is_charge_generale: 0,
        doc_table_column: "",
        already_exists: false,
        keyId: uniqid(),
      });
    }
  },
  methods: {
    close() {
      this.$emit("closeModalReqCols");
    },
    async set() {
      this.isChargeGeneral = false;
      this.requiredColumnsOnImport["*voting_categories*"].forEach(async votingCategory => {
        if (votingCategory.is_charge_generale == 1) {
          this.isChargeGeneral = true;
        }
      });
      if (!this.isChargeGeneral) {
        return;
      }
      this.$emit("IMPORT");
    },
    addVotingCategory() {
      // console.log("add voting category");
      this.requiredColumnsOnImport["*voting_categories*"].push({
        name: "",
        is_charge_generale: 0,
        doc_table_column: "",
        already_exists: false,
        keyId: uniqid(),
      });
    },
    removeVotingCategory(index) {
      // console.log("remove voting category");
      this.requiredColumnsOnImport["*voting_categories*"].splice(index, 1);
    },
    setOtherChargeGeneraleToFalse(votingCategoryIndex) {
      this.isChargeGeneral = true;
      this.requiredColumnsOnImport["*voting_categories*"].forEach((element, elementIndex) => {
        if (votingCategoryIndex !== elementIndex) {
          this.requiredColumnsOnImport["*voting_categories*"][elementIndex].is_charge_generale = 0;
        }
      });
    },
    checkIfRequired(field) {
      let found = this.$_.find(this.notRequired, notRequiredField => {
        return notRequiredField == field;
      });
      if (found) {
        return "";
      } else {
        return "required";
      }
    },
    customOptions(field) {
      let options = [...this.importedFileHeaderColumns];
      let isRequired = this.checkIfRequired(field);
      if (isRequired != "required") {
        options.unshift("-----------");
      }
      return options;
    },
    onVotingCategoryOptionChange(columnName, votingCategoryIndex) {
      this.requiredColumnsOnImport["*voting_categories*"][votingCategoryIndex].name = columnName;
    },
  },
};
</script>
